import React from "react"

interface Props {
	title?: string
	countryCodeValue: string
	countryCodeOnChange: any
	phoneNumberValue: string
	phoneNumberOnChange: any
}

export default function PhoneNumber({
	title = "Phone Number",
	countryCodeValue,
	countryCodeOnChange,
	phoneNumberValue,
	phoneNumberOnChange,
}: Props) {
	return (
		<div className="field">
			<label className="label">{title}</label>
			<div className="field-body">
				<p className="control">
					<a className="button is-static">+</a>
				</p>
				<div className="control">
					<input
						className="input"
						placeholder="Country Code"
						type="text"
						value={countryCodeValue}
						pattern="^(1|7|(\d{2,3})|(1\d{3}))$"
						required={!!phoneNumberValue}
						onChange={(e) => countryCodeOnChange(e.target.value)}
					/>
				</div>
				<div className="control w-100">
					<input
						className="input"
						placeholder="Number"
						type="text"
						value={phoneNumberValue}
						pattern="^\d+$"
						required={!!countryCodeValue}
						onChange={(e) => phoneNumberOnChange(e.target.value)}
					/>
				</div>
			</div>
		</div>
	)
}
